<template>
  <div class="">
    <div id="components-form-demo-advanced-search">
      <a-form
              class="ant-advanced-search-form"
              :form="form"
              @submit="handleSearch"
      >
        <a-row :gutter="24">

          <a-col :span="8">
            <a-form-item label="行政区划：">
              <a-cascader :options="optionAreas"
                          v-model="areaIds"
                          :showSearch="showSearch"
                          @change="areaChange"
                          placeholder="请选择"
                          expandTrigger="hover"/>
            </a-form-item>
          </a-col>

          <a-col :span="4">
            <a-form-item label="名称：">
              <a-input placeholder="请输入名称进行查询" v-model="param.name" @pressEnter="getList(0)"/>
            </a-form-item>
          </a-col>


          <a-col :span="4">
            <a-form-item label="公司类型：">
              <a-select v-model="param.privil" placeholder="请选择" @change="compTypeChange">
                <a-select-option value="">全部</a-select-option>
                <a-select-option :value="item.value" v-for="(item,index) in userList" :key="index">
                  {{ item.desc }}
                </a-select-option>
              </a-select>
            </a-form-item>
          </a-col>


          <a-col :span="6" :style="{ textAlign: 'right' }">
            <a-button type="primary" html-type="submit">
              查询
            </a-button>
            <a-button type="primary" :style="{ marginLeft: '8px' }" @click="toCreate">
              新建
            </a-button>
          </a-col>
        </a-row>
      </a-form>
      <!-- 表格 -->
      <div class="table">
        <a-table
                :columns="columns"
                :dataSource="dataList"
                :pagination="pagination"
                rowKey="id"
                @change="TableChange"
        >
          <template slot="serial" slot-scope="text, record, index">
            <template>
              {{ ((pagination.current - 1)*pagination.pageSize) + (index+1) }}
            </template>
          </template>
          <a slot="name" slot-scope="text">{{ text }}</a>

          <template slot="privil" slot-scope="text, record, index">
            <template>
              {{text | privilFilter}}
            </template>
          </template>

          <template slot="opera" slot-scope="text,record">
            <a-tag slot="opera" color="green" @click="toEdit(record)"  style="cursor: pointer;">
              编辑
            </a-tag>
            <a-tag slot="opera" color="volcano" @click="deleteData(record)"  style="cursor: pointer;">
              删除
            </a-tag>
          </template>
        </a-table>

      </div>
    </div>

    <!-- 删除弹框 -->
    <div>
      <a-modal
              title="提示"
              :visible="visible"
              :confirm-loading="confirmLoading"
              @ok="handleOk"
              @cancel="handleCancel"
              ok-text="确认" cancel-text="取消"
      >
        <p>{{ ModalText }}</p>
      </a-modal>
    </div>
  </div>
</template>
<script>

import { compList,deleteComp } from '@/api/comp/comp'
import { getAreaTree } from '@/api/area/index'

const columns = [
  {
    title: "序号 ",
    dataIndex: "serial",
    key: "serial",
    scopedSlots: { customRender: 'serial' }
  },
  {
    title: "公司 ",
    dataIndex: "name",
    key: "name"
  },
  {
    title: "联系人 ",
    key: "relax",
    dataIndex: "relax"
  },
  {
    title: "联系电话",
    key: "phone",
    dataIndex: "phone"
  },
  {
    title: "类型",
    key: "privil",
    dataIndex: "privil",
    scopedSlots: { customRender: 'privil' }
  },
  {
    title: "地址",
    key: "address",
    dataIndex: "address"
  },
  {
    title: "操作 ",
    key: "opera",
    dataIndex: "opera",
    scopedSlots: { customRender: "opera" }
  }
];

const dataList = [
];

export default {
  data() {
    return {
      pagination: {
        current: 1,
        pageNo: 1,
        pageSize: 10, // 默认每页显示数量
        showSizeChanger: true, // 显示可改变每页数量
        pageSizeOptions: ['10', '20', '30'], // 每页数量选项
        showTotal: total => `共有 ${total} 条`, // 显示总数
        //onChange: (page, pageSize) => this.changePage(page, pageSize), // 点击页码事件
        total: 0 // 总条数
      },

      form: this.$form.createForm(this, {
        name: "" ,
      }),
      param:{
        size: 10,
        page: 1,
        name: "" ,
        areaId:"",
        agePeriod:"",
        privil:"",
      },
      dataList,
      columns,
      ModalText: '确定要删除该信息吗？',
      visible: false,
      confirmLoading: false,

      userName: "",

      areaIds: [0,0,0],
      optionAreas: [
        {
          value: '0',
          label: '全国'
        }
      ],
      showSearch: {
        filter: (inputValue, path) => {
          return path.some(option => {
                    // label搜索
                    return fullText(inputValue, option.label);
                  }
          )
        },
        matchInputWidth: true
      },

      id: 0,

      trueList: [
        {value: 0,desc: '否'},
        {value: 1,desc: '是'}
      ],
      userList: [
        {value: 0,desc: '总公司'},
        {value: 1,desc: '分公司'},
        {value: 2,desc: '经销商'}
      ],
    };
  },
  computed: {
  },
  filters: {
    trueFilter (status) {
      if(status === 0)
        return "否"
      else if(status === 1)
        return "是"
      else
        return "否"
    },
    privilFilter (status) {
      if(status === 0)
        return "总公司"
      else if(status === 1)
        return "分公司"
      else if(status === 2)
        return "经销商"
      else
        return "未配置"
    },
  },
  created() {
    var userId = localStorage.getItem("userId")
    var areaId = localStorage.getItem("userAreaId")
    // 获取当前账号信息
    this.param.areaId = 0
    // 获取区划列表
    this.getAreaTree()

    this.getList(0);
  },
  updated() {
    console.log("updated");
  },
  methods: {

    getAreaIds () {
      var mfind = false;
      if(this.optionAreas != null && this.optionAreas.length > 0)
      {
        for(let i=0;i<this.optionAreas.length;i++)
        {
          if(this.optionAreas[i].value == this.param.areaId)
          {
            this.areaIds = [this.optionAreas[i].value,this.optionAreas[i].value]
            mfind = true;
            break;
          }
          else if(this.optionAreas[i].children!=null && this.optionAreas[i].children.length > 0)
          {
            for(let j=0;j<this.optionAreas[i].children.length;j++)
            {
              if(this.optionAreas[i].children[j].value == this.param.areaId)
              {
                this.areaIds = [this.optionAreas[i].value,this.optionAreas[i].children[j].value,this.optionAreas[i].children[j].value]

                mfind = true;
                break;
              }
              else  if(this.optionAreas[i].children[j].children!=null && this.optionAreas[i].children[j].children.length > 0)
              {
                for(let k=0;k<this.optionAreas[i].children[j].children.length;k++) {
                  if (this.optionAreas[i].children[j].children[k].value == this.param.areaId) {
                    this.areaIds = [this.optionAreas[i].value, this.optionAreas[i].children[j].value, this.optionAreas[i].children[j].children[k].value]

                    mfind = true;
                    break;
                  }
                }
              }
              if(mfind)
                break;
            }
            if(mfind)
              break;
          }
        }
      }
    },

    compTypeChange(value) {
      this.getList(0)
    },


    areaChange (value) {
      this.param.areaId = value[value.length - 1]
      this.getList(0)

    },
    getAreaTree () {
      getAreaTree({areaId:this.param.areaId}).then(response => {
        this.optionAreas = response.data

        this.getAreaIds();

      })
    },


    getList(number) {


      if (number === 0) {
        this.pagination.current = 1
        this.param.page = 1
      }

      var param = this.param


      compList(param).then(response => {
        this.dataList = response.data.list
        if (this.dataList) {
          this.pagination.total = response.data.total
        }
        else{
          this.pagination.total = 0;
        }
      })
    },

    // 搜索
    handleSearch(e) {

      e.preventDefault();

      this.form.validateFields((error, values) => {
        console.log("error", error);
        console.log("Received values of form: ", values);
      });

      this.getList(0);
    },
    handleChange(value){
      console.log(value)
      this.param.sex = value;
    },

    //打开删除弹框
    deleteData(value) {
      console.log(value)
      this.id = value.id;
      this.visible = true;
    },
    //确定删除
    handleOk() {
      this.visible = false;
      let _this = this;
      deleteComp({
        id: _this.id
      }).then(res => {
        console.log(res);
        _this.$message.success("删除成功", function() {
          _this.getList(0);
        });
      }).catch(err => {
        _this.$message.error(err.message);
      });
    },
    //取消删除
    handleCancel() {
      this.visible = false;
    },
    //新建
    toCreate() {
      this.$router.push({
        path: "/index/edit/compedit"
      });
    },
    //新建/编辑/查看
    toEdit(value) {
      console.log(value);
      this.id = value.id;
      this.$router.push({
        path: "/index/edit/compedit",
        query: {
          id: this.id
        }
      });
    },
    TableChange (e) {
      // 每页数量变更
      this.pagination.current = e.current
      this.param.page = e.current
      this.param.size = e.pageSize
      this.getList()
    },
    changePage (page, pageSize) {
      // 页码变更
      this.pagination.current = page
      this.param.page = page
      this.param.size = pageSize
      this.getList()
    },
  }
};
</script>
<style scoped>
  .ant-advanced-search-form {
    padding: 24px;
    background: #ffffff;
    /* border: 1px solid #d9d9d9; */
    /* border-radius: 6px; */
  }

  .ant-advanced-search-form .ant-form-item {
    display: flex;
  }

  .ant-advanced-search-form .ant-form-item-control-wrapper {
    flex: 1;
  }

  #components-form-demo-advanced-search .ant-form {
    max-width: none;
  }
  #components-form-demo-advanced-search .search-result-list {
    margin-top: 16px;
    border: 1px dashed #e9e9e9;
    border-radius: 6px;
    background-color: #ffffff;
    min-height: 200px;
    text-align: center;
    padding-top: 80px;
  }
  .table {
    margin-top: 20px;
    background: #ffffff;
    padding: 20px;

  }
  /deep/ .ant-table-tbody > tr > td {
    padding: 5px 5px!important;
  }

</style>
